/**
 * Validation utility functions.
 */
import { SUPPORTED_CURRENCIES } from '../constants/appConstants';

export function isNonEmptyString(value: unknown): boolean {
  return typeof value === 'string' && value.trim().length > 0;
}

export function isValidAmount(value: unknown): boolean {
  if (!isNonEmptyString(value)) return false;
  const str = value as string;
  const num = Number(str);
  if (isNaN(num) || num <= 0) return false;
  const parts = str.split('.');
  if (parts.length > 2) return false;
  if (parts.length === 2 && parts[1].length > 2) return false;
  return true;
}

export function isValidCurrency(value: unknown): boolean {
  if (!isNonEmptyString(value)) return false;
  return SUPPORTED_CURRENCIES.includes((value as string).toUpperCase());
}

export function isValidEmail(value: unknown): boolean {
  if (!isNonEmptyString(value)) return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test((value as string).trim());
}

export function sanitizeString(value: unknown): string {
  if (typeof value !== 'string') return '';
  return value.trim().replace(/<[^>]*>/g, '');
}
